import { createUserWithEmailAndPassword, signInWithEmailAndPassword } from 'firebase/auth';
import { doc, setDoc, getDoc } from 'firebase/firestore';
import { auth, db } from '../firebase.js';
import { UserRole } from '../types/auth.ts';

interface TestUser {
  email: string;
  password: string;
  displayName: string;
  role: UserRole;
}

const testUsers: TestUser[] = [
  {
    email: 'admin@company.com',
    password: 'password123',
    displayName: '관리자',
    role: 'admin'
  },
  {
    email: 'manager@company.com',
    password: 'password123',
    displayName: '매니저',
    role: 'manager'
  },
  {
    email: 'viewer@company.com',
    password: 'password123',
    displayName: '뷰어',
    role: 'viewer'
  },
  {
    email: 'employee@company.com',
    password: 'password123',
    displayName: '직원',
    role: 'employee'
  }
];

export async function setupTestUsers() {
  console.log('🚀 테스트 사용자 설정 시작...');
  
  const results = [];
  
  for (const testUser of testUsers) {
    try {
      // 먼저 로그인 시도 (이미 존재하는지 확인)
      console.log(`📧 ${testUser.email} 확인 중...`);
      
      try {
        await signInWithEmailAndPassword(auth, testUser.email, testUser.password);
        console.log(`✅ ${testUser.email} - 이미 존재함`);
        
        // Firestore 문서 확인 및 업데이트
        const userDocRef = doc(db, 'users', auth.currentUser!.uid);
        const userDoc = await getDoc(userDocRef);
        
        if (!userDoc.exists()) {
          console.log(`📝 ${testUser.email} - Firestore 문서 생성 중...`);
          await setDoc(userDocRef, {
            email: testUser.email,
            displayName: testUser.displayName,
            role: testUser.role,
            customPermissions: [],
            revokedPermissions: [],
            createdAt: new Date(),
            lastLogin: new Date()
          });
          console.log(`✅ ${testUser.email} - Firestore 문서 생성 완료`);
        }
        
        results.push({ email: testUser.email, status: 'existing', success: true });
      } catch (loginError: any) {
        // 사용자가 없으면 생성
        if (loginError.code === 'auth/user-not-found' || loginError.code === 'auth/invalid-credential') {
          console.log(`🔨 ${testUser.email} - 새 사용자 생성 중...`);
          
          const userCredential = await createUserWithEmailAndPassword(
            auth,
            testUser.email,
            testUser.password
          );
          
          // Firestore에 사용자 문서 생성
          await setDoc(doc(db, 'users', userCredential.user.uid), {
            email: testUser.email,
            displayName: testUser.displayName,
            role: testUser.role,
            customPermissions: [],
            revokedPermissions: [],
            createdAt: new Date(),
            lastLogin: new Date()
          });
          
          console.log(`✅ ${testUser.email} - 생성 완료`);
          results.push({ email: testUser.email, status: 'created', success: true });
        } else {
          throw loginError;
        }
      }
    } catch (error: any) {
      console.error(`❌ ${testUser.email} - 오류:`, error.message);
      results.push({ email: testUser.email, status: 'error', success: false, error: error.message });
    }
  }
  
  console.log('📊 테스트 사용자 설정 완료:', results);
  return results;
}

export async function verifyTestUser(email: string, password: string) {
  try {
    console.log(`🔍 ${email} 인증 테스트 중...`);
    
    // Firebase Auth 로그인 시도
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    console.log('✅ Firebase Auth 로그인 성공');
    
    // Firestore 사용자 문서 확인
    const userDoc = await getDoc(doc(db, 'users', userCredential.user.uid));
    if (userDoc.exists()) {
      console.log('✅ Firestore 사용자 문서 확인:', userDoc.data());
      return { success: true, data: userDoc.data() };
    } else {
      console.error('❌ Firestore 사용자 문서 없음');
      return { success: false, error: 'Firestore 사용자 문서가 없습니다' };
    }
  } catch (error: any) {
    console.error('❌ 인증 실패:', error.code, error.message);
    return { success: false, error: error.message };
  }
}